import React from "react";
import { useParams } from "react-router-dom";

import CategoryUpdatePage from "components/pages/ActivityDiscipline/CategoryUpdate";

const CategoryUpdate = () => {
  const { id } = useParams();

  return <CategoryUpdatePage id={id} />;
};

export default CategoryUpdate;
